{
  "date_must_be_today_or_later": "Дата должна быть сегодня или позже",
  "additional_compensation_amount_required": "Укажите одну из сумм",
  "duration_exceeds_max_hours": "Длительность не может превышать {hours} ч",
  "end_date_should_be_greater_start_date": "Дата окончания не может быть раньше даты начала",
  "end_time_should_be_greater_start_time": "Время окончания не может быть раньше времени начала",
  "field_email_required": "Поле должно содержать действующий адрес электронной почты",
  "field_number_required": "Нужно ввести числовое значение",
  "field_required": "Обязательно для заполнения",
  "field_url_invalid": "Введите корректный URL",
  "forms_validation_error": "Выберите форму для каждого типа рецензентов, чтобы продолжить",
  "no_file_selected": "Выберите файл для загрузки",
  "image_min_size": "Изображение должно быть не меньше {size}x{size}px",
  "invalid_decimal_format": "Введите число, используя не более двух знаков после запятой",
  "only_one_file_allowed_generic": "Пожалуйста, загрузите только один файл",
  "only_one_file_allowed": "Пожалуйста, загрузите только один файл с одним из следующих расширений: {formats}",
  "page_not_found": "Страница, которую вы ищете, недоступна",
  "page_not_found_description": "Извините за неудобства, страница, к которой вы пытаетесь получить доступ, была удалена или никогда не существовала",
  "password_required": "Пароль обязателен",
  "plan_inactive_description": "Ваш доступ ограничен. Пожалуйста, свяжитесь со службой поддержки %APP_NAME% по адресу {email}, чтобы восстановить свой план",
  "plan_inactive_title": "Ваш план истек",
  "crash_title": "Упс, что-то сломалось",
  "crash_description": "Мы уже получили информацию об ошибке. Вернитесь на главную и попробуйте снова.",
  "reviewers_validation_error": "Выберите хотя бы один тип рецензентов, чтобы продолжить",
  "server_error": "Упс! Что-то пошло не так с нашей стороны. Пожалуйста, попробуйте позже",
  "unsupported_file_format": "Этот формат файла не поддерживается. Загрузите файл с одним из следующих расширений: {formats}",
  "value_cannot_be_negative": "Значение не может быть отрицательным",
  "~": "~",
  "field_max_length": "Максимум {characters}"
}
